import { closeModal } from "./helpers/close-modal";
import { openModal } from "./helpers/open-modal";

const SizeGuide = () => {
  const opener = document.querySelector(".size-guide__modal-opener");
  const sizeGuideModal = document.querySelector(".size-guide__modal");

  if (opener) {
    opener.addEventListener("click", () => openModal(sizeGuideModal));
  }

  if (sizeGuideModal) {
    const closer = sizeGuideModal.querySelector(".size-guide__closer");
    const overlay = sizeGuideModal.querySelector(".size-guide__overlay");

    if (closer) {
      closer.addEventListener("click", () => closeModal(sizeGuideModal));
    };

    if (overlay) {
      overlay.addEventListener("click", () => closeModal(sizeGuideModal));
    };
  }
}

export default SizeGuide;